import { ChakraProvider, extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
    config: {
        initialColorMode: 'light',
        useSystemColorMode: false,
    },
    fonts: {
        heading: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        body: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    },
    styles: {
        global: (props) => ({
            body: {
                backgroundColor: 'rgba(46,76,107,1.0)',
            },
        }),
    },
    components: {
        Text: {
            baseStyle: {
                marginBottom: '0px',
            },
        },
        Modal: {
            baseStyle: {
                modal: {
                    borderRadius: '0px',
                },
            },
        },
        Button: {
            baseStyle: {
                borderRadius: '0px',
            },
            variants: {
                black: {
                    bg: 'rgba(0,0,0,0.9)',
                    color: 'white',
                    height: '40px',
                    borderRadius: '0px',
                    border: '1px solid rgba(0,0,0,1.0)',
                    _hover: {
                        bg: 'rgba(0,0,0,95)',
                        _disabled: {
                            bg: 'rgba(0,0,0,85)',
                        },
                    },
                    _active: {
                        bg: 'rgba(0,0,0,1.0)',
                    },
                    _disabled: {
                        bg: 'rgba(0,0,0,1.0)',
                    },
                },
                blackOutline: {
                    bg: 'none',
                    border: '1px solid rgba(0,0,0,0.9)',
                    _hover: {
                        border: '1px solid rgba(0,0,0,0.9)',
                    },
                    _active: {
                        border: '1px solid rgba(0,0,0,0.9)',
                    },
                    borderRadius: '0px',
                    color: 'black',
                    height: '40px',
                    _disabled: {
                        bg: 'rgba(0,0,0,1.0)',
                    },
                },
                blackOutline2: {
                    bg: 'none',
                    border: '1px solid rgba(0,0,0,0.1)',
                    _hover: {
                        border: '1px solid rgba(0,0,0,0.2)',
                    },
                    _active: {
                        border: '1px solid rgba(0,0,0,0.2)',
                    },
                    borderRadius: '0px',
                    color: 'black',
                    height: '40px',
                    _disabled: {
                        bg: 'rgba(0,0,0,0.1)',
                    },
                },
            },
        },
    },
});

export default ({ children }) => {
    return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
};
